import React, { FC, forwardRef, useState } from 'react';
import { IconButton } from '@components/buttons/IconButton/IconButton.component';
import { EyeIcon } from '@components/icons/Eye.icon';
import { EyeSlashIcon } from '@components/icons/EyeSlash.icon';
import { Input, InputProps } from '@form/components/Input/Input.component';

type Props = Omit<InputProps, 'type' | 'rightIcon'>;

export const PasswordInput: FC<Props> = forwardRef(({ style = {}, value, ...rest }, passwordInputRef) => {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  const { color } = style;
  return (
    <Input
      ref={passwordInputRef}
      className="plc-mb-basis"
      rightIcon={
        isPasswordVisible ? (
          <IconButton onClick={() => setIsPasswordVisible(false)}>
            <EyeSlashIcon fillColor={color} height="24" width="24" />
          </IconButton>
        ) : (
          <IconButton onClick={() => setIsPasswordVisible(true)}>
            <EyeIcon fillColor={color} height="24" width="24" />
          </IconButton>
        )
      }
      style={style}
      type={isPasswordVisible ? 'text' : 'password'}
      value={value || ''}
      {...rest}
    />
  );
});
